/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { FlashWallet, FlashWalletInterface } from "../FlashWallet";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "target",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "callData",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "executeCall",
    outputs: [
      {
        internalType: "bytes",
        name: "resultData",
        type: "bytes",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "target",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "callData",
        type: "bytes",
      },
    ],
    name: "executeDelegateCall",
    outputs: [
      {
        internalType: "bytes",
        name: "resultData",
        type: "bytes",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "success",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "success",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceID",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "hasSupport",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "tokenFallback",
    outputs: [],
    stateMutability: "pure",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

export class FlashWallet__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<FlashWallet> {
    return super.deploy(overrides || {}) as Promise<FlashWallet>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): FlashWallet {
    return super.attach(address) as FlashWallet;
  }
  connect(signer: Signer): FlashWallet__factory {
    return super.connect(signer) as FlashWallet__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): FlashWalletInterface {
    return new utils.Interface(_abi) as FlashWalletInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FlashWallet {
    return new Contract(address, _abi, signerOrProvider) as FlashWallet;
  }
}
